import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  background: rgba(106, 160, 241, 0.2);
  display: flex;
  height: 40px;
  justify-content: center;
  position: fixed;
  right: 0;
  top: 112px;
  width: 328px;
  z-index: 3000;
`;
